<template>
    <div class="snapshot">
        <snap-title :title="title" :time="$ft.uppercase(timeRange)">
        </snap-title>
        <report-mb
            v-if="isMobileSize"
            :soldListing="soldListing"
            :avgSalePrice="avgSalePrice"
            :avgDaysOnMarket="avgDaysOnMarket"
        ></report-mb>
        <report-pc
            v-else
            :soldListing="soldListing"
            :avgSalePrice="avgSalePrice"
            :avgDaysOnMarket="avgDaysOnMarket"
        ></report-pc>
    </div>
</template>

<script>
import ReportPc from './pc';
import ReportMb from './mobile';
import common from '../../../_mixins/market-report/common';
import Title from '../title';

export default {
    name: 'market-report',
    mixins: [common],
    components: {
        'report-pc': ReportPc,
        'report-mb': ReportMb,
        'snap-title': Title
    }
};
</script>
